/*
  订单相关接口
*/

import axiosInstance from './axiosInstance';

// 上传图片、视频接口
export const feedbackMediaUploadApi = async (params: { keys: string[] }) => {
  try {
    const response = await axiosInstance.post(
      `/influencer/uploadLinkBatch/public`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};
